import { Box, Typography } from '@material-ui/core';
import { Document } from '@roc/feature-types';
import { StandardDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import { useLoanStore } from '@roc/feature-loans';
import { AppraisalOrderDetailsDashboards } from 'libs/feature-documents/src/documents/components/documentForms/appraisalOrderAndCDADetails/appraisalOrderDetailsTab/AppraisalOrderDetailsDashboards';

/**
 * Shown while the appraisal is unpaid. The borrower can no longer pay from here: the Tamarisk payment flow's public
 * endpoints are gone, and the AMC payment link points to the /amc-payments page that client-portal-public no longer
 * serves. Point the borrower to the loan coordinator rather than open an empty modal or a 404.
 */
const AppraisalPaymentUnavailableMessage = () => (
  <Box textAlign="center" py={6} px={2} maxWidth={520} mx="auto">
    <Typography variant="h5" gutterBottom>
      Appraisal payment
    </Typography>
    <Typography color="textSecondary">
      Please contact your loan coordinator to complete the appraisal payment.
    </Typography>
  </Box>
);

export type TamariskAppraisalOrderPaymentContainerProps = {
  loanId?: string;
  open?: boolean;
  onClose?: () => void;
  document: Document;
  loanDetails?: any;
};

export const TamariskAppraisalOrderPaymentContainerDialog = observer(
  (props: TamariskAppraisalOrderPaymentContainerProps) => {
    const { loanStore } = useLoanStore();
    const { loanId, open, onClose, document,  loanDetails } = props;
    const loan = loanStore.loanDetails;
    const isTamariskPaymentDone =
      loan?.loanDepositData &&
      loan?.loanDepositData?.depositReceived &&
      (loan.loanDepositData.depositType === 'Appraisal_Standalone' ||
        loan.loanDepositData.depositType === 'Appraisal_Loan' ||
        loan.loanDepositData.depositType === 'ARR_CDA_Loan' ||
        loan.loanDepositData.depositType === 'CDA_Loan' ||
        loan.loanDepositData.depositType === 'AMC_Loan');

    return (
      <StandardDialog
        open={open}
        title="Appraisal Details"
        maxWidth="lg"
        handleClose={onClose}
        removeContentBox
        dialogContent={
          <Box width={'100%'}>
            {isTamariskPaymentDone ? (
              <AppraisalOrderDetailsDashboards
                loanId={loanId}
                isInternal={false}
              />
            ) : (
              <AppraisalPaymentUnavailableMessage />
            )}
          </Box>
        }
      />
    );
  }
);
